import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { addArtwork } from '../../lib/firebase/firestore'; 

export const AddArtworkPage = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [tags, setTags] = useState('');
  const [year, setYear] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!imageUrl) return alert('Please enter an image URL');

    setLoading(true);

    try {
      console.log('Attempting to add software offering:', {
        title,
        description,
        imageUrl,
        tags: tags.split(',').map(t => t.trim()),
        year: parseInt(year),
      });

      await addArtwork({
        title,
        description,
        imageUrl,
        tags: tags.split(',').map(t => t.trim()),
        year: parseInt(year),
      });

      console.log('software offering added successfully!');
      navigate('/admin/artworks'); // Redirect to artworks list
    } catch (error) {
      console.error('Error adding software offering:', error);
      alert('Failed to add software offering. Please try again.');
    }

    setLoading(false);
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Add New software offering</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          style={{ width: '100%', marginBottom: '1rem', padding: '0.5rem' }}
        />

        <textarea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
          style={{ width: '100%', marginBottom: '1rem', padding: '0.5rem' }}
        />

        <input
          type="text"
          placeholder="Tags (comma-separated)"
          value={tags}
          onChange={(e) => setTags(e.target.value)}
          required
          style={{ width: '100%', marginBottom: '1rem', padding: '0.5rem' }}
        />

        <input
          type="number"
          placeholder="Year"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          required
          style={{ width: '100%', marginBottom: '1rem', padding: '0.5rem' }}
        />

        <input
          type="url"
          placeholder="Image URL"
          value={imageUrl}
          onChange={(e) => setImageUrl(e.target.value)}
          required
          style={{ width: '100%', marginBottom: '1rem', padding: '0.5rem' }}
        />

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '0.75rem',
            backgroundColor: '#000',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          {loading ? 'Saving...' : 'Save offering'}
        </button>
      </form>
    </div>
  );
};